import React, { PropTypes } from 'react'
import { connect } from 'react-redux'
import Modal from 'bisu-react-modal'

const SessionOutDialog = ({ __userID }) => {
  if (__userID) {
    return null
  }

  return (
    <Modal className="modal-dialog2 modal-sm" overlayClassName="modal-overlay2" contentLabel="modal" isOpen>
      <div className="modal-content2">
        <div className="modal-header"><h3>Session Timed-out</h3></div>
        <div className="modal-body">Your session has timed out. Please login again.</div>
        <div className="modal-footer">
          <a href="/login" className="btn btn-warning">Login Again</a>
        </div>
      </div>
    </Modal>
  )
}

SessionOutDialog.propTypes = {
  __userID: PropTypes.number,
}

function mapStateToProps(state) {
  return {
    __userID: state.auth.get('userID'),
  }
}

export default connect(mapStateToProps)(SessionOutDialog)



// WEBPACK FOOTER //
// ./src/components/SessionOutDialog/index.js